/** Section review lifecycle values — mirrors the SectionStatus union type. */
export const SECTION_STATUS = {
  UNVIEWED: "unviewed",
  VIEWED: "viewed",
  REJECTED: "rejected",
} as const;

/** Document viewer state machine values — mirrors the DocState union type in components/types.ts. */
export const DOC_STATE = {
  COLLAPSED: "collapsed",
  PREVIEW: "preview",
  REJECTING: "rejecting",
  REJECTED: "rejected",
} as const;

/** Sentinel reason value that requires an accompanying free-text comment. */
export const REJECTION_REASON = {
  OTHERS: "Others",
} as const;
